import request from "./request";
import { setSystemId, setSystemName} from "./systemInfo";

export default {
  getSystemInfo: async function(){
    await request({
      url: "/systemName",
      method: "get",
      params: {
        domain: document.domain,
      },
    }).then((rsp) => {
      if (rsp.resultCode === "0" && !!rsp.data) {
        setSystemId(rsp.data.id);
        setSystemName(rsp.data.name);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/getSystem.js